import HTTPClient from '../common/http-client'

/**
 * すべてのサービスの基本クラス。
 */
export default class BaseService {
  /**
   * デフォルトのコンストラクター。
   */
  constructor() {
    const httpClientInstance = HTTPClient.getInstance()
    this.httpBlob = httpClientInstance.httpBlob
    this.http = httpClientInstance.http
    this.httpLogin = httpClientInstance.httpLogin
    this.httpMock = httpClientInstance.httpMock
    this.httpMedia = httpClientInstance.httpMedia
    this.httpUsers = httpClientInstance.httpUsers
    this.httpUsersNoToken = httpClientInstance.httpUsersNoToken
    this.httpPlusHub = httpClientInstance.httpPlusHub
    this.httpStatic = httpClientInstance.httpStatic
  }
}



// WEBPACK FOOTER //
// ./src/_services/base.service.js